<template>
  <div>
    <el-card>
      <table-list :data="[topicRow]" :show-page="false">
        <el-table-column :label="$t('序号')" type="index" align="center" width="50"/>
        <el-table-column :label="$t('名称')" align="center" prop="name"/>
        <el-table-column :label="$t('内容描述')" align="center" prop="content"/>
        <el-table-column :label="$t('图片')" align="center">
          <template v-slot="{row}">
            <preview-img :size="60" :img-url="row.photo"></preview-img>
          </template>
        </el-table-column>
        <el-table-column :label="$t('参与人数')" align="center" prop="joinCount"/>
        <el-table-column :label="$t('优先级')" align="center" prop="priority"/>
      </table-list>
    </el-card>

    <el-card class="mt16">
      <template #header>
        <h4>{{ $t('话题详情') }}</h4>
      </template>

      <el-form inline size="small">
        <el-form-item :label="$t('发布者编号')">
          <el-input :placeholder="$t('发布者编号')" v-model="searchForm.userNum" clearable/>
        </el-form-item>
        <el-form-item :label="$t('发布者昵称')">
          <el-input :placeholder="$t('发布者昵称')" v-model="searchForm.username" clearable/>
        </el-form-item>
        <el-form-item :label="$t('搜索内容')">
          <el-input :placeholder="$t('搜索内容')" v-model="searchForm.content" clearable/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
          <el-button @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
        </el-form-item>
      </el-form>

      <div class="flex-end mb16">
        <el-button size="small" type="danger" @click="handleBatchDelete">{{ $t('批量删除') }}</el-button>
        <el-button size="small" type="primary" @click="handleBatchRecommend">{{ $t('批量精品置顶') }}</el-button>
      </div>

      <table-list
          ref="list"
          :search-params="searchForm"
          :request-params="{topicCode: $route.query.code}"
          @query="handleSearch"
          @selection-change="selection = $event"
          :data="tableData">
        <el-table-column type="selection" width="50"/>
        <el-table-column :label="$t('编号')" prop="num"/>
        <el-table-column :label="$t('内容')" prop="content"/>
        <el-table-column :label="$t('图片')">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <template v-for="(pic, index) in row.photoList">
                <img v-if="index < 1" class="el-image"  :key="index"
                     :src="$api.file.downloadImg + pic"/>
              </template>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('发布者编号')" prop="userNum"/>
        <el-table-column :label="$t('发布者昵称')" prop="username"/>
        <el-table-column :label="$t('评论数')">
          <template v-slot="{row}">
            <el-link type="primary" :underline="false" @click="handleCommentPage(row)">{{ row.commentCount || 0 }}</el-link>
          </template>
        </el-table-column>
        <el-table-column :label="$t('点赞数')" prop="likeCount"/>
        <el-table-column :label="$t('发布时间')" prop="createTimeStr"/>
        <el-table-column :label="$t('精品置顶')" prop="topping"/>
        <el-table-column :label="$t('操作')" width="160">
          <template v-slot="{row}">
            <div class="fb-link-flex ">
              <el-link :underline="false" type="primary" @click="$router.push('/dynamic/detail?code=' + row.code)">
                {{ $t('查看') }}
              </el-link>
              <el-link :underline="false" type="primary" @click="handleSetTop(row)">{{ row.topping === "1" ? $t('取消置顶') : $t('置顶') }}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{ $t('删除') }}</el-link>
            </div>
          </template>
        </el-table-column>

      </table-list>

    </el-card>
  </div>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

export default {
  name: "TopicDynamic",
  components: {PreviewImg, TableList},
  data() {
    return {
      tableData: [],
      selection: [],
      searchForm: {},
      topicRow: {}
    }
  },
  methods: {
    // 前往评论页面
    handleCommentPage(row) {
      this.$router.push({
        path: "/comment/list",
        query: {
          code: row.code,
          num: row.num,
        }
      })
    },

    // 置顶
    async handleSetTop(row) {
      try {
        const message = row.topping === "1" ? this.$t('是否取消置顶？') : this.$t('是否置顶？');
        const topping = row.topping === "1" ? "0" : "1";
        await requestByTip(this.$api.dynamics.updateStatus, {topping, code: row.code}, {}, {message});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    // 批量设置推荐
    async handleBatchRecommend() {
      try {
        let codes = this.selection.map(item => item.code);
        if (!codes.length) {
          this.$message.warning(this.$t('请选择要操作的数据'));
          return;
        }
        await requestByTip(this.$api.dynamics.batchUpdate, codes, {isJson: true}, {message: this.$t('是否确认设置为精品置顶')});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.dynamics.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if(!codes.length) {
          this.$message.warning(this.$t('请选择要操作的数据'));
          return;
        }
        await requestByTip(
            this.$api.dynamics.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest(codes.length);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params) {
      try {
        const res = await request(this.$api.dynamics.list, params);
        this.tableData = res.dynamicss.map(item => {
          item.photoList = item.photo ? item.photo.split(',') : [];
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          return item;
        });
      } catch (e) {
        console.log(e);
      }
    },

    async handleLoadDetail() {
      try {
        const res = await request(this.$api.topicSort.detail, this.$route.query);
        console.log('res', res);
        this.topicRow = res.topicSort;
      } catch (e) {
        console.log(e);
      }
    }
  },
  created() {
    this.handleLoadDetail();
  }
}
</script>

<style scoped>

</style>
